(function primaryNavigation($, Drupal, once) {
  Drupal.behaviors.rutherfordPrimaryNavigation = {
    drilldown(context) {
      $(once(
        'rutherford-primary-navigation-mobile',
        '.primary-navigation[data-drilldown]',
        context
      ))
        .each(function eachNav() {
          // This event listener only fires once.
          document.addEventListener(
            'create-drilldown',
            e => {
              // eslint-disable-next-line no-new
              new Foundation.Drilldown($(this));
            },
            { once: true },
          );

          $(window).on('changed.zf.mediaquery', () => {
            $('.primary-navigation')
              .closest('.is-drilldown')
              .attr('style', '');
          });

          $('.drilldown .submenu[role=group]:not([aria-label])', context).each(
            function addMissingGroupLabels() {
              const label = $(this)
                .closest('.is-drilldown-submenu-parent')
                .attr('aria-label');
              $(this).attr('aria-label', label);
            },
          );

          $('.primary-navigation [role="treeitem"]', context).each(
            function addMissingAriaSelected() {
              $(this).attr('aria-selected', 'false');
            },
          );

          $('.primary-navigation a', context)
            .filter(function findLinksToCurrentPage() {
              return (
                $(this)
                  .prop('href')
                  .indexOf(window.location.pathname) !== -1
              );
            })
            .closest('[role="treeitem"]')
            .attr('aria-selected', 'true');
        });
    },
    dropdown(context) {
      $(once(
        'rutherford-primary-navigation-desktop',
        '.primary-navigation[data-dropdown-menu]',
        context
      ))
        .each(function eachNav() {
          const _dropdownMenu = new Foundation.DropdownMenu($(this));
          $(this).removeClass('primary-navigation--loading');
        });

      Drupal.behaviors.rutherfordPrimaryNavigation.setPositionCssVariables();
      window.addEventListener(
        'resize',
        _.debounce(
          Drupal.behaviors.rutherfordPrimaryNavigation.setPositionCssVariables,
          100,
        ),
      );
    },
    createAppropriateNavigation(context) {
      if (Foundation.MediaQuery.atLeast('xl')) {
        Drupal.behaviors.rutherfordPrimaryNavigation.dropdown(context);
      } else {
        // Lazyload in bodyScrollLock.
        loadjs(
          `/themes/custom/rutherford/libraries/body-scroll-lock/lib/bodyScrollLock.min.js`,
        );
        Drupal.behaviors.rutherfordPrimaryNavigation.drilldown(context);
      }
    },
    attach(context) {
      Drupal.behaviors.rutherfordPrimaryNavigation.createAppropriateNavigation(
        context,
      );

      $(window).on('changed.zf.mediaquery', () => {
        Drupal.behaviors.rutherfordPrimaryNavigation.createAppropriateNavigation(
          context,
        );
      });
    },
    setPositionCssVariables() {
      const { x, width } = document
        .querySelector('.primary-navigation[data-dropdown-menu]')
        .getBoundingClientRect();

      document.documentElement.style.setProperty(
        '--primary-dropdown-r-pos',
        `${x + width}px`,
      );
    },
  };
})(jQuery, Drupal, once);
